import { persistBreadcrumbs } from '../internal/integrations/sentry';
import { ILoggerConfig } from '../internal/types';

import { Logger } from './Logger';

/**
 * Convenience function to create and initialize logger
 * @param config - Logger configuration
 * @returns Initialized Logger instance
 */
export function createLogger(config: ILoggerConfig): Logger {
	return Logger.initialize(config);
}

export { persistBreadcrumbs };
